// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-progress-container {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 50000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  max-width: 400px;
  pointer-events: none;
}

.download-progress-container > * {
  pointer-events: auto;
}

.download-progress-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.download-progress-site-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: rgba(17, 24, 39, 0.85);
  color: #fff;
  border-radius: 8px;
  font-size: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  align-self: flex-end;
}

.download-progress-site-status-label {
  color: rgba(255, 255, 255, 0.78);
}

.download-progress-site-ping {
  background: transparent;
  padding: 0;
}

.download-progress-loader-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  font-size: 13px;
  color: #fff;
}

.download-progress-loader-text {
  color: rgba(255, 255, 255, 0.92);
}

.download-progress-spinner--paused {
  animation: none;
  opacity: 0.6;
}

.download-progress-item {
  width: 100%;
  background: #3B82F6;
  border: none;
  border-radius: 12px;
  padding: 16px 20px;
  color: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  font-size: 14px;
  font-weight: 500;
}

.download-progress-item--completed {
  background: #10B981;
}

.download-progress-item--completed.download-progress-item--warning {
  background: #F59E0B;
}

.download-progress-item--error {
  background: #EF4444;
}

.download-progress-item--paused {
  background: #3B82F6;
}

@keyframes downloadProgressIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.download-progress-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.download-progress-item-header-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.download-progress-ping {
  padding: 2px 4px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.06);
}

.download-progress-speed-hint {
  cursor: help;
  color: #d1d5db;
}

.download-progress-item-title {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.78);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.download-progress-item-action {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: rgba(0, 0, 0, 0.12);
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.15s, color 0.15s;
}

.download-progress-item-action:hover {
  background: rgba(0, 0, 0, 0.22);
  color: #fff;
}

.download-progress-item-body {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 13px;
  color: #fff;
}

.download-progress-stream-block {
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}

.download-progress-stream-label {
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.3;
}

.download-progress-spinner {
  animation: downloadProgressSpin 0.8s linear infinite;
  color: #fff;
}

@keyframes downloadProgressSpin {
  to {
    transform: rotate(360deg);
  }
}

.download-progress-bar-wrap {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.28);
  border-radius: 3px;
  overflow: hidden;
}

.download-progress-bar {
  height: 100%;
  min-height: 6px;
  background: #fff;
  border-radius: 3px;
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/** Stream sin Content-Length: franja móvil sobre el 100% del contenedor. */
.download-progress-bar--indeterminate {
  width: 100% !important;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.28) 0%,
    rgba(255, 255, 255, 0.74) 40%,
    #fff 50%,
    rgba(255, 255, 255, 0.74) 60%,
    rgba(255, 255, 255, 0.28) 100%
  );
  background-size: 200% 100%;
  animation: downloadIndeterminate 1.1s ease-in-out infinite;
  border-radius: 3px;
}

@keyframes downloadIndeterminate {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

/** Sin porcentaje exacto pero con bytes: barra aprox. + leve brillo. */
.download-progress-bar--indeterminate-rough {
  min-width: 4%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.62) 0%, #fff 50%, rgba(255, 255, 255, 0.78) 100%);
  background-size: 200% 100%;
  animation: downloadIndeterminateRough 2s ease-in-out infinite;
}

@keyframes downloadIndeterminateRough {
  0%,
  100% {
    background-position: 0% 0;
    filter: brightness(0.95);
  }
  50% {
    background-position: 100% 0;
    filter: brightness(1.1);
  }
}

.download-progress-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.82);
}

.download-progress-btn-text {
  padding: 0;
  border: none;
  background: transparent;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
}

.download-progress-btn-text:hover {
  color: rgba(255, 255, 255, 0.86);
}

.download-progress-btn-text.primary {
  margin-left: auto;
}

.download-progress-completed-block {
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}

.download-progress-completed-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.download-progress-completed-row > span {
  font-size: 12px;
  line-height: 1.4;
  flex: 1 1;
}

.download-progress-completed-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.download-progress-icon.success {
  color: #fff;
  flex-shrink: 0;
}

.download-progress-icon.warning {
  color: #fff;
  flex-shrink: 0;
}

.download-progress-icon.error {
  color: #fff;
}

.download-progress-clear {
  padding: 6px 12px;
  font-size: 12px;
  border: none;
  background: rgba(0, 0, 0, 0.38);
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.download-progress-clear:hover {
  background: rgba(0, 0, 0, 0.48);
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/DownloadProgress.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA,2EAA2E;AAC3E;EACE,sBAAsB;EACtB;;;;;;;GAOC;EACD,0BAA0B;EAC1B,0DAA0D;EAC1D,kBAAkB;AACpB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,0GAA0G;EAC1G,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE;;IAEE,yBAAyB;IACzB,wBAAwB;EAC1B;EACA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb","sourcesContent":[".download-progress-container {\n  position: fixed;\n  top: 24px;\n  right: 24px;\n  z-index: 50000;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  max-width: 400px;\n  pointer-events: none;\n}\n\n.download-progress-container > * {\n  pointer-events: auto;\n}\n\n.download-progress-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.download-progress-site-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  background: rgba(17, 24, 39, 0.85);\n  color: #fff;\n  border-radius: 8px;\n  font-size: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  align-self: flex-end;\n}\n\n.download-progress-site-status-label {\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.download-progress-site-ping {\n  background: transparent;\n  padding: 0;\n}\n\n.download-progress-loader-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  font-size: 13px;\n  color: #fff;\n}\n\n.download-progress-loader-text {\n  color: rgba(255, 255, 255, 0.92);\n}\n\n.download-progress-spinner--paused {\n  animation: none;\n  opacity: 0.6;\n}\n\n.download-progress-item {\n  width: 100%;\n  background: #3B82F6;\n  border: none;\n  border-radius: 12px;\n  padding: 16px 20px;\n  color: #fff;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.download-progress-item--completed {\n  background: #10B981;\n}\n\n.download-progress-item--completed.download-progress-item--warning {\n  background: #F59E0B;\n}\n\n.download-progress-item--error {\n  background: #EF4444;\n}\n\n.download-progress-item--paused {\n  background: #3B82F6;\n}\n\n@keyframes downloadProgressIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.download-progress-item-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.download-progress-item-header-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.download-progress-ping {\n  padding: 2px 4px;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.download-progress-speed-hint {\n  cursor: help;\n  color: #d1d5db;\n}\n\n.download-progress-item-title {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.78);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.download-progress-item-action {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  background: rgba(0, 0, 0, 0.12);\n  color: rgba(255, 255, 255, 0.85);\n  cursor: pointer;\n  border-radius: 8px;\n  transition: background 0.15s, color 0.15s;\n}\n\n.download-progress-item-action:hover {\n  background: rgba(0, 0, 0, 0.22);\n  color: #fff;\n}\n\n.download-progress-item-body {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  font-size: 13px;\n  color: #fff;\n}\n\n.download-progress-stream-block {\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n  width: 100%;\n}\n\n.download-progress-stream-label {\n  margin: 0;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.78);\n  line-height: 1.3;\n}\n\n.download-progress-spinner {\n  animation: downloadProgressSpin 0.8s linear infinite;\n  color: #fff;\n}\n\n@keyframes downloadProgressSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.download-progress-bar-wrap {\n  width: 100%;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.28);\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.download-progress-bar {\n  height: 100%;\n  min-height: 6px;\n  background: #fff;\n  border-radius: 3px;\n  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/** Stream sin Content-Length: franja móvil sobre el 100% del contenedor. */\n.download-progress-bar--indeterminate {\n  width: 100% !important;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.28) 0%,\n    rgba(255, 255, 255, 0.74) 40%,\n    #fff 50%,\n    rgba(255, 255, 255, 0.74) 60%,\n    rgba(255, 255, 255, 0.28) 100%\n  );\n  background-size: 200% 100%;\n  animation: downloadIndeterminate 1.1s ease-in-out infinite;\n  border-radius: 3px;\n}\n\n@keyframes downloadIndeterminate {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n/** Sin porcentaje exacto pero con bytes: barra aprox. + leve brillo. */\n.download-progress-bar--indeterminate-rough {\n  min-width: 4%;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.62) 0%, #fff 50%, rgba(255, 255, 255, 0.78) 100%);\n  background-size: 200% 100%;\n  animation: downloadIndeterminateRough 2s ease-in-out infinite;\n}\n\n@keyframes downloadIndeterminateRough {\n  0%,\n  100% {\n    background-position: 0% 0;\n    filter: brightness(0.95);\n  }\n  50% {\n    background-position: 100% 0;\n    filter: brightness(1.1);\n  }\n}\n\n.download-progress-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.82);\n}\n\n.download-progress-btn-text {\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: #fff;\n  font-size: 12px;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.download-progress-btn-text:hover {\n  color: rgba(255, 255, 255, 0.86);\n}\n\n.download-progress-btn-text.primary {\n  margin-left: auto;\n}\n\n.download-progress-completed-block {\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n}\n\n.download-progress-completed-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.download-progress-completed-row > span {\n  font-size: 12px;\n  line-height: 1.4;\n  flex: 1;\n}\n\n.download-progress-completed-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.download-progress-icon.success {\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.download-progress-icon.warning {\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.download-progress-icon.error {\n  color: #fff;\n}\n\n.download-progress-clear {\n  padding: 6px 12px;\n  font-size: 12px;\n  border: none;\n  background: rgba(0, 0, 0, 0.38);\n  color: #fff;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.download-progress-clear:hover {\n  background: rgba(0, 0, 0, 0.48);\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
